module.exports = __webpack_public_path__ + "img/boxing.9da2a969.png";